import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:[],
  aditems:[],
  city:[],
  region:[],
  item:{

  }
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_ADDRESS (state, isLoading){
    state.status.loading = isLoading
  },
  SET_ADDRESS (state, data){
    state.items = data
  },
  SET_ADDRESS_DELIVERY_TYPE (state, data){
    state.aditems = data
  },
  SET_CITY (state, data){
    state.city = data
  },
  SET_REGION (state, data){
    state.region = data
  },
  SET_ERROR (state, error){
    state.status.error = error
  },
  REMOVE_ADDRESS_ITEM (state, item){
    var items = JSON.parse(JSON.stringify(state.items)); //without copying it will not work
    var index = state.items.findIndex(o => o.id === item.id);
    if(index >=0){
      items.splice(index, 1)
      state.items = items; //update by index will not work
    }
    else console.error('Item not found in address Store state')


  },
  SET_ADDRESS_ITEM (state, item){
    state.item = item
  },
}

//async methods store.dispatch('increment')
const actions = {

  //load all addresses
  loadAddress ({state, commit}) {
    commit('LOADING_ADDRESS', true);
    return api.get('address')
      .then(function (response) {
        commit('SET_ADDRESS', response.data.data);
        commit('LOADING_ADDRESS', false);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);
      });
  },
  
  loadAddressDeliveryType ({state, commit}, cartid) {
    commit('LOADING_ADDRESS', true);
    return api.get('addressdeliverytype/' + cartid)
      .then(function (response) {
        commit('SET_ADDRESS_DELIVERY_TYPE', response.data.data);
		commit('SET_ADDRESS', response.data.addresses);
        commit('LOADING_ADDRESS', false);
		return Promise.resolve({ 'address_id': response.data.address_id, 'delivery_type_id': response.data.delivery_type_id, 'extra_delivery': response.data.extra_delivery });
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);
		return Promise.resolve(error);
      });
  },

  loadAddressItem ({state, commit}, id) {

    commit('LOADING_ADDRESS', true);

    return api.get('address/'+id)
      .then(function (response) {

        commit('LOADING_ADDRESS', false);
        commit('SET_ADDRESS_ITEM', response.data.data);

        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);

        //commit('SET_ERROR', error.response.data.error)
        return Promise.reject(error);

      });
  },

  loadCity ({state, commit}) {

    commit('LOADING_ADDRESS', true);

    return api.get('city')
      .then(function (response) {
        commit('SET_CITY', response.data.data)
        commit('LOADING_ADDRESS', false);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);

      });
  },

  loadRegion ({state, commit}) {

    commit('LOADING_ADDRESS', true);

    return api.get('region')
      .then(function (response) {
        commit('SET_REGION', response.data.data)
        commit('LOADING_ADDRESS', false);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);

      });
  },

  addAddress ({state, commit}, addressItem) {

    commit('LOADING_ADDRESS', true);

    return api.post('address', addressItem)
      .then(function (response) {

        commit('LOADING_ADDRESS', false);

        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);

        commit('SET_ERROR', error.response.data.error)
        return Promise.reject(error);

      });
  },

  updateAddress ({state, commit}, addressItem) {

    commit('LOADING_ADDRESS', true);

    return api.post('address/'+addressItem.id, addressItem)
      .then(function (response) {

        commit('LOADING_ADDRESS', false);

        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);

        commit('SET_ERROR', error.response.data.error)
        return Promise.reject(error);

      });
  },

  deleteAddress ({state, commit}, addressItem) {

    commit('LOADING_ADDRESS', true);

    return api.delete('address/'+ addressItem.id)
      .then(function (response) {
        commit('LOADING_ADDRESS', false);
        commit('REMOVE_ADDRESS_ITEM', addressItem)
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_ADDRESS', false);
        return Promise.reject(error);

      });
  },

}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AddressStore.js